const firstLettersToUpperCase = (input?: string) => {
  input = ( input === undefined || input === null ) ? '' : input
  return input.replace( /(^|\. *)([a-z])/g, (match, separator, char) => {
      return separator + char.toUpperCase();
  });
}

export default firstLettersToUpperCase